<div class="md-input-container">
    <mat-form-field class="mat-form-withtooltip" style="width: 60%;">
        <mat-label *ngIf="disabled">{{label}} *</mat-label>
        <mat-label *ngIf="!disabled">{{label}}</mat-label>
        <mat-select [(ngModel)]="value" name="manager" (openedChange)="onOpen($event)"
        [compareWith]="objectComparison" [disabled]="disabled"
                    #payrate="ngModel"
                    [required]="required"
        [panelClass]="isLoading || !isOpen ? 'hide-dummy-option' : ''"
        >
            <mat-option *ngIf="!items || !items.length" class="minh88" disabled>
                <div class="select-placeholder-container">
                    <mat-spinner class="spinner" diameter="20"></mat-spinner>
                </div>
            </mat-option>
            <mat-option *ngFor="let item of items" [value]="item">{{item.Name}}</mat-option>
        </mat-select>
        <mat-error  class="md-errormsg"  *ngIf="!payrate.valid && payrate.touched && required">Required</mat-error>
    </mat-form-field>
    <mat-icon *ngIf="showHelpText" [matTooltip]="helptext" matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
        help
    </mat-icon>
</div>
<mat-error class="sm-errormsg" *ngIf="!payrate.valid && payrate.touched && required">Required</mat-error>
